import React from 'react';
import { useHistory } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { Button, Paper, Typography } from '@mui/material';

import { BackButton, PageTitle, Radio, RadioLabel } from '../../../../../components/common';
import ButtonContainer from '../../../../../components/ButtonContainer';

import { StyledRadioContainer, StyledListItem } from './ListWithRadioButton.styled';

function ListWithRadioButton(props) {
  const {
    name,
    backButtonLink,
    nextButtonLink,
    pageTitleId,
    pageTitleValues,
    listConfig,
    selected,
    setSelected,
  } = props;

  const history = useHistory();

  const questions = Array.isArray(listConfig) ? listConfig : [];

  const handleRadioBtnClick = (value) => (ev) => {
    if (ev) ev.stopPropagation();
    setSelected(value);
  };

  return (
    <>
      <BackButton to={backButtonLink}>
        <Typography variant="h3">
          <FormattedMessage id="common.button.back" />
        </Typography>
      </BackButton>

      <PageTitle>
        <Typography variant="h1">
          <FormattedMessage id={pageTitleId} values={pageTitleValues} />
        </Typography>
      </PageTitle>

      <StyledRadioContainer>
        {questions.map((question) => {
          const { label, noTranslateLabel, value } = question || {};

          return (
            <Paper key={value}>
              <StyledListItem onClick={handleRadioBtnClick(value)}>
                <Radio
                  name={name}
                  onChange={handleRadioBtnClick(value)}
                  value={value}
                  checked={value === selected}
                />

                <RadioLabel style={{ marginLeft: '1rem' }}>
                  {noTranslateLabel ? (
                    <Typography variant="p" color="professional_blue">
                      {noTranslateLabel}
                    </Typography>
                  ) : (
                    <Typography variant="p" color="professional_blue">
                      <FormattedMessage id={label} />
                    </Typography>
                  )}
                </RadioLabel>
              </StyledListItem>
            </Paper>
          );
        })}
      </StyledRadioContainer>

      <ButtonContainer>
        <Button disabled={!selected} onClick={() => history.push(nextButtonLink)}>
          <Typography variant="buttons">
            <FormattedMessage id="common.button.next" />
          </Typography>
        </Button>
      </ButtonContainer>
    </>
  );
}

export default ListWithRadioButton;

ListWithRadioButton.defaultProps = {
  pageTitleValues: {},
};

ListWithRadioButton.propTypes = {
  name: PropTypes.string.isRequired,
  backButtonLink: PropTypes.string,
  nextButtonLink: PropTypes.string,
  pageTitleId: PropTypes.string,
  pageTitleValues: PropTypes.instanceOf(Object),
  listConfig: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      noTranslateLabel: PropTypes.string,
      value: PropTypes.string,
    })
  ),
  selected: PropTypes.string,
  setSelected: PropTypes.func,
};
